var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"botao-redondo",on:{"click":_vm.acao}},[_c('div',{staticClass:"botao-redondo__icone"},[(_vm.$slots.default)?_vm._t("default"):_vm._e()],2),_c('p',{staticClass:"botao-redondo__titulo"},[_vm._v(_vm._s(_vm.titulo))])])
}
var staticRenderFns = []

export { render, staticRenderFns }